import React from 'react';
import { AwardIcon, CheckCircle2Icon } from 'lucide-react';
import { Button } from './ui/Button';
import { SectionHeading } from './ui/SectionHeading';
import { assurances, checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="bg-navy-light py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-123" data-mp="1ja0dw0krprkr">
      <div className="mx-auto max-w-3xl px-4" data-id="element-124" data-mp="1n9ireba9f0dk">
        <SectionHeading id="pricing-title" data-id="element-125" data-mp="1ncwp367zaleo">Scegli la tua <span className="text-energy" data-id="element-126" data-mp="1s8lx7xy2daml">opzione</span></SectionHeading>

        <article id="offerta" className="mt-10 scroll-mt-6 overflow-hidden rounded-3xl border-2 border-gold bg-navy shadow-2xl" data-id="element-127" data-mp="1x8zucky4n05u">
          <div className="border-b border-gold/30 bg-navy-card px-6 py-4 sm:px-10" data-id="element-128" data-mp="226rshwpd7iih">
            <span className="inline-flex items-center gap-2 rounded-full border border-energy/50 bg-energy/10 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.14em] text-cream" data-id="element-129" data-mp="2vh1hof1k5qv">
              <AwardIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-130" data-mp="1mh6kkza8f25g" /> Offerta principale
            </span>
          </div>
          <div className="p-6 sm:p-10" data-id="element-131" data-mp="1hp6fytj7vl2j">
            <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-132" data-mp="1cqv309xmkug3">
              <div data-id="element-133" data-mp="1coilfxvs4m3k">
                <h3 className="text-2xl font-extrabold uppercase leading-tight tracking-tight text-cream sm:text-3xl" data-id="element-134" data-mp="17s1xb3oky7qh">{productShortName}</h3>
                <p className="mt-2 text-sm text-haze" data-id="element-135" data-mp="25f0oiywi6ngz">
                  Tutti i {totalVolumes} volumi + {totalBonuses} bonus esclusivi
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-136" data-mp="1vgl7xpv3qwlq">
                <span className="text-sm text-haze" data-id="element-137" data-mp="1vj7f3oe2za3f">
                  Prezzo normale: <span className="line-through decoration-gold decoration-2" data-id="element-138" data-mp="1rf805a8g8jc6">{priceBefore}</span>
                </span>
                <p className="mt-2 text-xs font-bold uppercase tracking-[.14em] text-gold" data-id="element-139" data-mp="k03bvqvf2vzm">Oggi:</p>
                <p className="mt-1 whitespace-nowrap text-5xl font-extrabold leading-none tracking-tight text-gold sm:text-6xl" data-id="element-140" data-mp="g2p505v7l0as">{price}</p>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-141" data-mp="mgcjc57iy2ye">
              Sì, voglio l&apos;Edizione Docenti
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-haze" data-id="element-142" data-mp="chndjaswk8yi">
              {assurances.map(item => <span key={item} className="inline-flex items-center gap-1.5" data-id="element-143" data-mp="3uul5ovjgdxi4">
                  <CheckCircle2Icon className="h-4 w-4 text-energy" aria-hidden="true" data-id="element-144" data-mp="3jjoi4ipku1y" /> {item}
                </span>)}
            </div>
          </div>
        </article>
      </div>
    </section>;
}